import colors from "config/colors";
import "./Spinner.scss";
const Spinner = ({ visible = true, size = null, color }: any) => {
  return <>{visible && <div className={`spinner ${size}`} style={{ borderColor: color ? color : null, borderTopColor: colors.light }}></div>}</>;
};

export { Spinner };
